module.exports = __webpack_public_path__ + "assets/img/outboundCallingBot-banner.b66d695f.png";